<template>
  <div
    class="booking-header-close"
    data-component="booking-header-close"
  >
    <button
      v-if="back"
      :aria-label="tc('booking.back')"
      class="icon-arrow-back"
      tabindex="0"
      @click="back"
      @keypress.enter.prevent="back"
      @keypress.space.prevent="back"
    />
    <div class="booking-header-close-title">
      <slot />
    </div>
    <button
      v-if="deactivate"
      :aria-label="tc('booking.close')"
      class="icon-close"
      tabindex="0"
      @click="deactivate"
      @keypress.enter.prevent="deactivate"
      @keypress.space.prevent="deactivate"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'HeaderClose',
    props: {
      deactivate: {
        type: Function
      },
      back: {
        type: Function
      }
    },
    computed: {
      ...mapState('modifyReservation', ['isBookingEditMode']),
      ...mapGetters('i18n', ['tc']),
    }
  }
</script>
